export enum StatusFile {
  ERROR = 'ALL ERROR',
  SUCCESS = 'SUCESSS',
  PROCESSED = 'PROCESSED',
  PARTIAL_PROCESSED = 'PARTIAL PROCESSED',
  PROCESSING = 'PROCESSING',
}
